import sun from "../images/carrot.png";
import "../styles/score.css";
import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaTimes, FaDownload } from "react-icons/fa";
import api from "./api";
import { Link } from "react-router-dom";
import moment from "moment-jalaali";

moment.loadPersian({ dialect: "persian-modern" });

const Score = () => {
    const [course, setCourse] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const translateValue = (value) => {
        const map = {
            excellent: "عالی",
            very_good: "خیلی خوب",
            good: "خوب",
            average: "متوسط",
            needs_improvement: "نیاز به تلاش بیشتر",
            poor: "ضعیف",
        };
        return map[value] || value;
    };

    useEffect(() => {
        api
            .get("student/api/v1/certificate-and-reportcarts")
            .then((res) => {
                setCourse(res.data);
            })
            .catch((err) => {
                console.error("خطا در دریافت لیست کلاس‌ها", err);
            });
    }, []);

    const handleShowModal = (courseItem) => {
        setSelectedCourse(courseItem);
        setShowModal(true);
    };

    const translateField = (field) => {
        const map = {
            homework: "تکالیف",
            class_participation: "فعالیت کلاسی",
            exercises: "تمرین‌ها",
            learning_speed: "سرعت یادگیری",
            attention: "توجه و دقت",
            teamwork: "کار گروهی",
            discipline: "انضباط",
            communication_skills: "مهارت‌های ارتباطی",
            typing_speed: "سرعت تایپ",
            computer_skills: "مهارت‌های کامپیوتری",
            final_project: "پروژه نهایی",
            comments: "توضیحات",
        };
        return map[field] || field;
    };

    return (
        <div className="me-lg-5 pe-lg-4">
            <div className="my-4">
                <span className="fw-bold me-5 me-lg-0 ms-3">کلاس های من</span>
                <img src={sun} width={33} height={33} />
            </div>

            <div className="row mx-5 me-lg-0 ms-lg-4">
                {course.map((c, i) => (
                    <div className="col-lg-3 col-12 mb-4" key={i}>
                        <div className="student-box stbox-before p-4 d-flex flex-column" style={{ height: "100%", minHeight: "200px" }}>
                            <div className="row">
                                {c.certificate && c.certificate.certificate_logo && (
                                    <div className="col-4">
                                        <img
                                            src={`${c.certificate.certificate_logo}`}
                                            alt=""
                                            width={50}
                                            height={50}
                                            style={{
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                            }}
                                        />
                                    </div>
                                )}

                                <div className={c.certificate && c.certificate.certificate_logo ? "col-8" : "col-12"}>
                                    <p className="mb-0">{c?.course_title}</p>
                                    <span className="teachers-name">{c?.teacher_name}</span>
                                </div>
                            </div>
                            <div className="row mt-4 flex-grow-1 align-items-end">
                                <div className={`col-6 justify-content-center d-flex ${!c.report_card && c.certificate ? 'offset-3' : ''}`}>
                                    {c.report_card && (
                                        <button
                                            className="upload-btn"
                                            style={{ width: "110px", height: "45px" }}
                                            onClick={() => handleShowModal(c)}
                                        >
                                            کارنامه
                                        </button>
                                    )}
                                </div>
                                <div className={`col-6 justify-content-center d-flex ${!c.report_card && c.certificate ? 'col-6' : ''}`}>
                                    {c.certificate && (
                                        <div
                                            className="upload-btn justify-content-center d-flex"
                                            style={{ width: "110px", color: "white" }}
                                        >
                                            <Link
                                                to={`/certificate/${c.certificate.id}`} 
                                                className="upload-btn"
                                                style={{ color: "white" }}
                                            >
                                                دانلود مدرک
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                centered
            >
                <Button
                    variant="secondary"
                    className="times"
                    onClick={() => setShowModal(false)}
                >
                    <FaTimes />
                </Button>
                <Modal.Body className="p-lg-5 pt-0" style={{ direction: "rtl" }}>
                    {!selectedCourse ? (
                        <p>در حال بارگذاری اطلاعات...</p>
                    ) : (
                        <>
                            {/* پنج آیتم بالای جدول */}
                            <div className="d-flex flex-wrap justify-content-center align-items-center w-100 text-center my-3">
                                <div className="homework-header py-2 m-2 px-3">
                                    نام دوره: {selectedCourse?.course_title}
                                </div>
                                <div className="homework-header py-2 m-2 px-3">
                                    نام مدرس: {selectedCourse?.teacher_name}
                                </div>
                                <div className="homework-header py-2 m-2 px-3">
                                    نام دانش‌آموز: {selectedCourse?.certificate?.student_full_name}
                                </div>
                                <div className="homework-header py-2 m-2 px-3">
                                    تاریخ صدور کارنامه:{" "}
                                    {selectedCourse?.report_card?.issue_date
                                        ? moment(selectedCourse.report_card.issue_date).format("jYYYY/jMM/jDD")
                                        : "-"}
                                </div>
                                <div className="homework-header py-2 mx-2 px-3">
                                    ارزیابی آخرین پروژه: {selectedCourse?.report_card?.final_project}
                                </div>
                            </div>

                            <div className="row m-lg-5 mt-5 mb-2">
                                <div className="col-lg-6 col-6">
                                    <div className="homework-detail">موضوع</div>
                                </div>
                                <div className="col-lg-6 col-6">
                                    <div className="homework-detail">ارزیابی</div>
                                </div>
                            </div>

                            {Object.entries(selectedCourse?.report_card || {})
                                .filter(([key]) =>
                                    !["id", "issue_date", "report_file", "final_project"].includes(key)
                                )
                                .map(([key, value], idx) => (
                                    <div className="row mx-lg-5 mx-2 mb-2" key={idx}>
                                        <div className="col-6">
                                            <div className="homework-detail bg-detail">
                                                {translateField(key)}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="homework-detail bg-detail">{translateValue(value)}</div>
                                        </div>
                                    </div>
                                ))}
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Score;